export default __webpack_public_path__ + "static/media/logoBPayVertical64.bcf0ab74.svg";